export enum ConstraintInstanceType {
  Proposal = 'proposal',
  Sleeve = 'sleeve',
}
